var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"vttinput",staticClass:"form-control form-control-sm",attrs:{"type":"text","tabindex":_vm.tabindex,"placeholder":'5:00',"disabled":_vm.disabled,"autocomplete":"off"},domProps:{"value":_vm.displayvalue},on:{"input":function($event){return _vm.keyDown($event)},"blur":function($event){return _vm.validateTimeInput()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }